import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { postApiCall } from 'api/apiService';
import { POST_AGENT_BANNER_CLOSE } from 'constant/app.config';
import { datacontext } from 'modules/AppLayout/AppLayout';
import React, { useContext, useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import Requestdeposit from 'component/BuyerRegistration/components/RequestDepositPopup';

const WarningIcon = (matchessm) => {
  return (
    <svg
      width={matchessm ? '46' : '66'}
      height={matchessm ? '46' : '66'}
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33 11C27.1652 11 21.5695 13.3179 17.4437 17.4437C13.3179 21.5695 11 27.1652 11 33C11 38.8348 13.3179 44.4305 17.4437 48.5564C21.5695 52.6822 27.1652 55 33 55C38.8348 55 44.4305 52.6822 48.5564 48.5564C52.6822 44.4305 55 38.8348 55 33C55 27.1652 52.6822 21.5695 48.5564 17.4437C44.4305 13.3179 38.8348 11 33 11ZM5.5 33C5.5 17.8118 17.8118 5.5 33 5.5C48.1882 5.5 60.5 17.8118 60.5 33C60.5 48.1882 48.1882 60.5 33 60.5C17.8118 60.5 5.5 48.1882 5.5 33Z"
        fill="white"
      />
      <path
        d="M33 38.5C32.2707 38.5 31.5712 38.2103 31.0555 37.6945C30.5397 37.1788 30.25 36.4793 30.25 35.75V19.25C30.25 18.5207 30.5397 17.8212 31.0555 17.3055C31.5712 16.7897 32.2707 16.5 33 16.5C33.7293 16.5 34.4288 16.7897 34.9445 17.3055C35.4603 17.8212 35.75 18.5207 35.75 19.25V35.75C35.75 36.4793 35.4603 37.1788 34.9445 37.6945C34.4288 38.2103 33.7293 38.5 33 38.5ZM28.875 45.375C28.875 44.281 29.3096 43.2318 30.0832 42.4582C30.8568 41.6846 31.906 41.25 33 41.25C34.094 41.25 35.1432 41.6846 35.9168 42.4582C36.6904 43.2318 37.125 44.281 37.125 45.375C37.125 46.469 36.6904 47.5182 35.9168 48.2918C35.1432 49.0654 34.094 49.5 33 49.5C31.906 49.5 30.8568 49.0654 30.0832 48.2918C29.3096 47.5182 28.875 46.469 28.875 45.375Z"
        fill="white"
      />
    </svg>
  );
};

const DepositPaymentOutstandingBanner = (props) => {
  const {
    bannerDetails,
    isAgentDashboard,
    getListInfo,
    AgentGroupCall,
    profileDetails,
    setOutstandingBannerClose,
  } = props;

  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const { setShowMessage, setMessagedata } = useContext(datacontext);

  const buyerName = bannerDetails?.winnerName ?? '-';
  const BuyerId = bannerDetails?.isWinnerId;
  const PropertyId = bannerDetails?.propertyId;
  const WinnerBinderId = bannerDetails?.isWinnerBinderId;
  const sendReminder = bannerDetails?.sendReminder === 0;

  const [
    endPropertyPopupFromNominateWinner,
    setEndPropertyPopupFromNominateWinner,
  ] = useState(false);
  const [manageOffer, setManageOffer] = useState(false);

  const manageOfferClick = () => {
    setManageOffer(true);
  };

  const [requestdeposit, setRequestdeposit] = useState(false);
  const [depositdetails, setDepositdetails] = useState(false);
  const [reqDepositOpen, setReqDepositOpen] = useState(false);
  const [selectedrowbuyerid, setSelectedrowbuyerid] = React.useState(false);
  const [depositRes, setDepositRes] = useState('');

  const history = useHistory();
  const onPropertyClick = (propertyId) => {
    history.push({
      pathname: `dashboard/view-dashboard/${propertyId}`,
      state: {
        dashboardPaymentOutstandingBanner: true,
      },
    });
  };

  const { bannerApiTrigger } = useContext(datacontext);

  const onOpen = () => {
    setRequestdeposit(true);
  };

  const location = useLocation();
  const hasOpenedRef = useRef(false);
  const { dashboardPaymentOutstandingBanner } = location?.state || {};

  useEffect(() => {
    if (dashboardPaymentOutstandingBanner && !hasOpenedRef.current) {
      hasOpenedRef.current = true;
      onOpen();
    }
  }, [dashboardPaymentOutstandingBanner, onOpen]);

  const onClose = () => {
    setRequestdeposit(false);
  };

  const [closeLoader, setCloseLoader] = useState(false);
  const handleDepositPaymentOutstaningCloseApiCall = async () => {
    const propertyId = Number(bannerDetails?.propertyId);
    let input = {
      propertyId: propertyId,
      bannerCode: 'AGENT003',
      bannerHeading: 'Deposit Payment Outstanding',
      buyerId: BuyerId,
    };

    try {
      setCloseLoader(true);

      const response = await postApiCall(POST_AGENT_BANNER_CLOSE, input);
      if (response?.data?.status == 1) {
        setOutstandingBannerClose((prev) =>
          prev.includes(propertyId) ? prev : [...prev, propertyId]
        );
        bannerApiTrigger();
        if (!isAgentDashboard) {
          setShowMessage(true);
          setMessagedata({ binderId: WinnerBinderId });
          getListInfo();
        }
        if (isAgentDashboard) {
          setShowMessage(true);
          setMessagedata({ binderId: WinnerBinderId });
          AgentGroupCall();
        }
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setCloseLoader(false);
    }
  };

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          background: '#E03942FA',
          width: '100%',
          borderRadius: '20px',
          p: matchessm ? 2 : 2,
          display: 'flex',
          flexDirection: 'row',
          height: matchessm ? 390 : matchesmd ? 330 : 300,
        }}
      >
        <Grid
          xs={12}
          container
          sx={{
            display: 'flex',
            alignItems: 'start',
            padding: matchessm ? 0.5 : 3,
          }}
        >
          <Grid item xs={12} padding={!matchessm && '0px 0 0 20px'}>
            <Typography
              sx={{
                fontSize: matchessm ? '14px' : '16px',
                fontFamily: 'Poppins !important',
                fontStyle: 'normal !important',
                fontWeight: 300,
                fontSize: '14px',
                color: 'white',
              }}
            >
              {bannerDetails?.propertyAddress}
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction={'row'}
            marginLeft={!matchessm && '-20px'}
            marginTop={matchessm ? '-135px' : '-30px'}
          >
            <Grid
              item
              xs={12}
              md={1}
              xl={0.5}
              sx={{
                display: matchesmd ? 'none' : 'flex',
                justifyContent: 'center',
                alignItems: 'baseline',
              }}
            >
              <WarningIcon />
            </Grid>
            <Grid item sm={12} md={12} lg={7.2} xl={7.7}>
              <Box
                sx={{
                  fontSize: !matches450 ? '32px' : '18px',
                  fontWeight: 600,
                  color: '#FFF',
                  fontFamily: 'poppins',
                  paddingBottom: matchessm ? 0 : matcheslg ? 2 : 3,
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: matchessm && '-10px',
                  gap: matchessm && 1,
                }}
              >
                {matchesmd && (
                  <Box>
                    <WarningIcon matchessm={matchessm} />
                  </Box>
                )}
                Deposit Payment Outstanding
              </Box>

              <Typography
                sx={{
                  fontSize: matchessm ? '14px' : '16px',
                  fontFamily: 'poppins',
                  fontWeight: 300,
                  color: '#FFF',
                  paddingBottom: matchessm ? 0 : 4,
                }}
              >
                Avoid delays and remind the Buyer{' '}
                <span
                  style={{
                    color: '#FFF',
                    fontWeight: matchessm ? 400 : 700,
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    textTransform: 'capitalize',
                  }}
                >
                  {buyerName}
                </span>{' '}
                to process their deposit payment for{' '}
                <Typography
                  component="span"
                  sx={{
                    color: '#FFF',
                    fontWeight: matchessm ? 400 : 700,
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    textTransform: 'capitalize',
                  }}
                >
                  {bannerDetails?.propertyAddress}.
                </Typography>
              </Typography>
            </Grid>
            <Grid
              item
              sm={12}
              md={12}
              lg={3.8}
              sx={{
                display: 'flex',
                alignItems: 'end',
                flexWrap: 'wrap',
                justifyContent: 'end',
                mt: matchessm && '10px',
                mb: matchessm ? -10 : -6,
              }}
              gap={matchessm ? 1 : 2}
            >
              <Button
                disabled={closeLoader}
                onClick={() => {
                  if (!sendReminder) {
                    handleDepositPaymentOutstaningCloseApiCall();
                  } else if (isAgentDashboard) {
                    onPropertyClick(PropertyId);
                    onOpen(); // REQUIRED
                  } else {
                    onOpen();
                  }
                }}
                endIcon={
                  closeLoader && (
                    <CircularProgress sx={{ color: '#262626' }} size="20px" />
                  )
                }
                sx={{
                  height: matchessm ? 35 : 42,
                  width: '155px',
                  borderRadius: '5px',
                  fontSize: matchessm ? '12px' : '14px',
                  textTransform: 'none',
                  border: '1px solid #E6F2FF',
                  backgroundColor: '#FFF',
                  color: '#262626',
                  fontWeight: 400,
                  fontFamily: 'poppins',
                  '&:hover': {
                    bgcolor: '#FFFFFF',
                    color: '#262626',
                  },
                }}
              >
                {sendReminder ? 'Request Deposit' : 'Send Reminder'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Card>
      {requestdeposit && (
        <Requestdeposit
          requestdeposit={requestdeposit}
          endPropertyPopupFromNominateWinner={
            endPropertyPopupFromNominateWinner
          }
          manageOfferClick={manageOfferClick}
          setRequestdeposit={setRequestdeposit}
          setReqDepositOpen={setReqDepositOpen}
          BuyerId={bannerDetails?.isWinnerId}
          getListInfo={getListInfo}
          row={bannerDetails}
          reqDepositOpen={reqDepositOpen}
          address={bannerDetails?.propertyAddress}
          depositRes={depositRes}
          setEndPropertyPopupFromNominateWinner={
            setEndPropertyPopupFromNominateWinner
          }
          profileDetails={profileDetails}
          fromOutstndingBanner={true}
          AgentGroupCall={AgentGroupCall}
        />
      )}
    </>
  );
};

export default DepositPaymentOutstandingBanner;
